import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties';

export const AnalogJointSchema = new GenericModelSchema('analogJoint', {
  category: ModelCategory.ComponentDesignData,

  properties: {
    name: StringProperty,
  },
});
